<template>
  <app-section-wrap :modifier="'login update-password'">
    <div column="xl-3">
      <password-validator
        v-model="passwordValid"
        v-if="!verifyingToken && !tokenError"
        :newPassword="newPassword"
        :confirmNewPassword="confirmNewPassword"
      />
    </div>
    <div column="xs-12 s-12 m-6 xl-6 ">
      <div class="card">
        <h1 class="_text-center _mbs">
          Reset Password
        </h1>
        <async-loader v-if="verifyingToken"/>
        <div v-else-if="tokenError || authError && !verifyingToken" class="_flex justify-center">
          <p class="lips text">{{authMessage}}</p>
        </div>
        <form v-if="!tokenError" @submit.prevent="resetPassword" method="POST">
          <div class="form-group">
            <label for="newPassword">
              New Password
            </label>
            <app-password-input
              class="_mbxs"
              id="newPassword"
              name="newPassword"
              value=""
              required
              autofocus="true"
              v-model="newPassword"
            />
            <label for="confirmNewPassword">
              Confirm New Password
            </label>
            <app-password-input
              id="confirmNewPassword"
              name="confirmNewPassword"
              value=""
              required
              v-model="confirmNewPassword"
            />
          </div>
          <async-button type="submit" class="_mtxs --sm" :executing="resettingPassword || retryingLogin" :disabled="passwordValid || retryingLogin">
            <template #buttonContent>
              <span>Reset Password</span>
            </template>
          </async-button>
        </form>
        <router-link to="/">Back to Sign In screen</router-link>
      </div>
    </div>

  </app-section-wrap>
</template>

<script>
  import AsyncLoader from '@molecules/AsyncLoader'
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import AsyncButton from '@molecules/AsyncButton.vue'
  import PasswordValidator from '@organisms/PasswordValidator'

  import AppPasswordInput from '@atoms/PasswordInput'
  import { mapGetters } from 'vuex'
  import loginable from '@mixins/loginable'
  import LoginApi from '@api/LoginApi'
  import { parseQueryParams } from '@/utils'

  export default {
    mixins: [loginable],
    components: {
      AsyncLoader,
      AppSectionWrap,
      AsyncButton,
      AppPasswordInput,
      PasswordValidator
    },
    data() {
      return {
        passwordValid: true,
        newPassword: '',
        userId: '',
        token: '',
        confirmNewPassword: ''
      }
    },
    computed: {
      ...mapGetters([
        'verifyingToken',
        'authMessage',
        'authError',
        'resettingPassword',
        'tokenError'
      ]),
      formObject() {
        return {
          newPassword: this.newPassword,
          userId: this.userId,
          token: this.token
        }
      }
    },
    methods: {
      resetPassword () {
        this.$store.dispatch('RESET_PASSWORD', {
          body: this.formObject
        })
          .then(success => {
            if (success) {
              this.loginWithRetries({ userId: this.formObject.userId, password: this.formObject.newPassword })
            }
          })
      }
    },
    beforeCreate() {
      this.$store.dispatch('cacheBuster/NUKE_STATE')
    },
    created() {
      new LoginApi().getDecryptedData({ body: this.$route.query })
        .then((res) => {
          const { userId, token } = parseQueryParams(res.data)
          this.userId = userId
          this.token = token
          return this.$store.dispatch('VERIFY_TOKEN', {
            body: { userId, token }
          })
        })
        .catch((error) => {
          console.error('Error during the API calls:', error);
        })
    }
  }
</script>
